/** GxCloseBanner (screens §2, §P6): inside the countdown's warning window, what goes in if the round closes now. Facilitated only. */
import type { TeamState } from "@bsim/contracts";
import { Icon } from "../theme/icons";
import { useNow } from "../shell/useNow";
import { closeBannerText } from "./close";
import "./signoff.css";

export function GxCloseBanner({ team }: { readonly team: TeamState }) {
  const now = useNow();
  const ends = team.round?.countdownEndsAt ?? null;
  const text = team.cohort.mode === "solo" || ends === null || team.round?.state !== "open" ? null : closeBannerText(team.draft?.closeFallback ?? null);
  const left = ends === null ? Infinity : Date.parse(ends) - now;
  if (text === null || left > team.cohort.countdownWarningMinutes * 60_000) return null;
  const mm = Math.max(0, Math.floor(left / 60_000));
  const ss = String(Math.max(0, Math.floor((left % 60_000) / 1000))).padStart(2, "0");
  return (
    <div className="gx-sign-closebanner" role="status" data-testid="decide.closebanner" data-kind={team.draft?.closeFallback?.kind}>
      <Icon name="warn" size={14} />
      <span>{text.lead === "" ? null : <b>{text.lead} </b>}{text.rest} · {mm}:{ss} left on the room clock</span>
    </div>
  );
}
